import httpInstance from '../httpInstance';

const getProvidersPaymentService = async () => {
  let res;
  const endpoint = '/service-payment/v1/beneficiaries/allinfo';
  await httpInstance.get(
    endpoint,
  ).then((data) => {
    res = data;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getProvidersPaymentService;
